import remotesConfig from 'remotesConfig'
import veComponentsMfeConfig from 'veComponentsMfeConfig'
import injectWindowVariables from '@ve/module-federation/injectWindowVariables'
import injectScripts from '@ve/module-federation/injectScripts'
if (veComponentsMfeConfig?.maintenance?.enabled) {
  injectWindowVariables(remotesConfig)
  import('./bootstrap')
} else {
  injectWindowVariables(remotesConfig)
  injectScripts(remotesConfig)
  import('./bootstrap')
}
export {}
